<ng-container *appTranslate="let t">
  <new-ui-dashboard-card>
    <ng-template #header>
      <new-ui-dashboard-card-header
        [title]="t('dashboard.candidateEvents.title', { eventCount: candidateEventsMetric()?.eventCounts ?? 0 })"
        routerLink="/app/candidates/events"
      >
        <div class="row">
          <p-select
            [ngModel]="selectedTimeframe()"
            (ngModelChange)="selectedTimeframe.set($event)"
            [options]="timeframes()"
          />
          <p-multiSelect
            [placeholder]="t('candidateEvent.category.title')"
            [showClear]="true"
            [ngModel]="selectedEventTypes()"
            (ngModelChange)="selectedEventTypes.set($event)"
            [options]="eventCategories()"
          />
        </div>
      </new-ui-dashboard-card-header>
    </ng-template>

    @if (candidateEventsMetric(); as metric) {
      @if (metric.events?.length > 0) {
        <new-ui-dashboard-list [values]="metric.events" />
      } @else {
        <ui-emptystate
          class="py-[3%]"
          image="/assets/layout/images/new-ui/search.png"
          [caption]="t('emptystate.events.title')"
          [description]="t('emptystate.events.description')"
        />
      }
    } @else {
      <ul class="col gap-4 p-0 pr-2">
        @for (item of [1, 2, 3]; track item) {
          <li class="flex flex-col mobile:flex-row gap-4 p-2 border border-surface-border rounded-lg shadow-sm">
            <div class="basis-1/2 row gap-2">
              <p-skeleton class="h-5 w-16" />
              <p-skeleton class="h-5 w-40" />
            </div>
            <div class="basis-1/2 row gap-2">
              <p-skeleton class="h-5 w-24" />
            </div>
          </li>
        }
      </ul>
    }
  </new-ui-dashboard-card>
</ng-container>
